module.exports = __webpack_public_path__ + "img/sicilians-DE.f20091db.png";